export class PreMatricula {

    preMatriculaId: number = 0;

    preMatriculaStatus: number = 0;

    dataCriacao: Date = new Date();

    alunoNome: string = '';

    alunoCpf: string = '';

    pagadorNome: string = '';

    pagadorEmail: string = '';

    pagadorCpf: string = '';

    pagadorLogradouro: string = '';

    pagadorLogradouroNumero: string = '';

    pagadorLogradouroComplemento: string = '';

    pagadorBairro: string = '';

    pagadorCep: string = '';

    pagadorTelefone: string = '';

    pagadorMunicipio: string = '';

    pagadorUf: string = '';

    periodo: number = 0;

    anoLetivoId: number = 0;

    turmaId: number = 0;

    saguiClienteId: number = 0;

    ciente: boolean = false;

    condicaoPagamentoId: number = 0;

    contaParcelaId: number = 0;

    responsavelClienteId: number = 0;

    pagadorUfId: number = 0;

    pagadorMunicipioId: number = 0;

    alunoId: number = 0;

    valorMatricula: number = 0;

    numParcelasMatricula: number = 0;

    valorParcelasMatricula: number = 0;

    formaDePagamentoMatricula: number = 0;

    totalMaterialDidatico: number = 0;

    numParcelasMaterialDidatico: number = 0;

    valorParcelasMaterialDidatico: number = 0;

    formaDePagamentoLivro: number = 0;

    totalMensalidade: number = 0;

    numParcelasMensalidade: number = 0;

    valorParcelasMensalidade: number = 0;

    formaDePagamentoMensalidades: number = 0;

    dataVencimentoBoletoMensalidade: number = 10;

    turmaPrecoId: number = 0;

    pagadorPaisId: number = 0;

    pagadorPais: number = 0;

    rematricula: boolean = true;
}
